import { getDefaultAsyncWrapperObj } from '@ane/core/lib/models';
import { loadResourcesUtils } from '@ane/core/lib/utils/LoadResourcesUtils';
import DataSourceResource from '../../../DataSource.resource';
import { convertToOverridePostParams } from '../../DataSourceOverrideCreate/components/CreateWizard/DataSourceCreateFormSettings';
import { convertToPostParams } from '../components/CreateWizard/DataSourceCreateFormSettings';
export const defaultReducerState = {
    items: getDefaultAsyncWrapperObj(),
};
// Action Types
const prefix = 'loadDataSourceDuplicate';
export const loadDataSourceDuplicateConstants = {
    SetDataSourceDuplicateItem: `${prefix}/SetDataSourceDuplicateItem`,
};
const loadDulplicateDataSourcesArgs = {
    actionPrefix: `${prefix}/LOAD`,
    reduxKeyNested: () => ['items'],
    loadResource: (inputPayload) => {
        let dataSourcePost;
        if (inputPayload.IsOverrideDataSource) {
            dataSourcePost = convertToOverridePostParams(inputPayload);
        }
        else {
            dataSourcePost = convertToPostParams(inputPayload);
        }
        return DataSourceResource.postDuplicateDataSource(dataSourcePost);
    },
    onCompleteSuccess: (resourceResult) => {
        return resourceResult;
    },
};
export const loadDulplicateDataSourcesEpicReducer = loadResourcesUtils(loadDulplicateDataSourcesArgs);
// Reducer
export const dataSourceDuplicateReducer = (state = defaultReducerState, action) => {
    state = loadDulplicateDataSourcesEpicReducer.reduxChange(state, action);
    if (action.type === loadDataSourceDuplicateConstants.SetDataSourceDuplicateItem) {
        return {
            ...state,
            items: action.payload,
        };
    }
    return state;
};
// Set dataSourceDuplicate object
export function SetDataSourceDuplicateItem(deleteDataSource) {
    return {
        type: loadDataSourceDuplicateConstants.SetDataSourceDuplicateItem,
        payload: deleteDataSource.items,
    };
}
export default dataSourceDuplicateReducer;

//# sourceMappingURL=DataSourceDuplicate.ducks.js.map
